module.exports = __webpack_public_path__ + "static/media/kitchener.058a2f90.jpg";